import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import DetailCardBody from '@/common/components/DetailCard/DetailCardBody';
import DetailCardItems from '@/common/components/DetailCard/DetailCardItems';
import FileHeader from '@/common/components/DetailCard/headers/fileHeader/FileHeader';
import MainDetailCard from '@/common/components/DetailCard/MainDetailCard';
import useInfinityScroll from '@/common/hooks/useInfinityScroll';
import LoadingPage from '@/common/pages/LoadingPage';
import { getOfflineFilesListQueryOptions } from '@/modules/OfflineFiles/queries/getOfflineFilesList/getOfflineFilesListQueryOptions';
import FileListDetailCardActions from '@/modules/FileList/components/fileDetailCardActions/FileListDetailCardActions';
import { useInfiniteQuery } from '@tanstack/react-query';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const UnCompletedFilesModal = ({ open, closeModal }: MainModalProps) => (
  <MainModal open={open} closeModal={closeModal}>
    <UnCompletedFiles />
  </MainModal>
);

const UnCompletedFiles = () => {
  const {
    data: filesList,
    isPending,
    fetchNextPage,
  } = useInfiniteQuery(getOfflineFilesListQueryOptions());
  const { observerRefCallback } = useInfinityScroll(fetchNextPage);
  if (isPending) {
    return <LoadingPage />;
  }
  return (
    <>
      <TitleDescription textStyle="h2" color="black-1">
        پرونده های تکمیل نشده
      </TitleDescription>
      <Typography textStyle="b1" color="black-1" mt="1rem">
        کارشناس محترم، جهت ارسال تصاویر و تکمیل پرونده ها اقدام نمایید.
      </Typography>
      <Box py="24px">
        {filesList?.pages.map((pageData, pageIndex) =>
          pageData.results.map((file, index) => (
            <Box key={file.id} ref={observerRefCallback}>
              <MainDetailCard
                className={css({
                  mb:
                    index === pageData.results?.length - 1 &&
                    filesList?.pages.length === pageIndex + 1
                      ? '100px'
                      : '20px',
                })}
              >
                <FileHeader
                  index={pageIndex * pageData.page_size + index + 1}
                  fileType={file.file_type.const}
                />
                <DetailCardBody>
                  <DetailCardItems items={file.detailCardItems ?? []} />
                </DetailCardBody>
                <FileListDetailCardActions action="enter" id={file.id} />
              </MainDetailCard>
            </Box>
          )),
        )}
      </Box>
    </>
  );
};
export default UnCompletedFilesModal;
